import React from 'react';

const TicBox = (props) => {
  return (
    <span className='Box' onClick={props.clickHandler}>{props.value}</span>
  )
};

export default TicBox;
